import React, {useEffect, useRef} from "react";

// import Container from "@mui/material/Container";
import {Modal as MUIModal} from "@mui/material";
import {checkNull, isBoolTrue, printLog} from "../utils/ReactUtils";
import DialogContent from "../content/DialogContent";
import {THEME} from "../config/FusionConfig";
import {AnimationType, FramerAnimator} from "../animation/FramerAnimator";

/**
 * PropTypes for the Modal component.
 *
 * @example
 *            <Dialog
 *                     open={showYTLinksDialog}
 *                     title={"YouTube Links"}
 *                     contentClassName={"scroller scroller-auto scroll-dark "}
 *                     height={"auto"}
 *                     maxHeight={"45vh"}
 *                     widthClass={"w-auto or col-sm-12 col-md-8"}
 *                     className={"p-0"}
 *                     titleClassName={"fs-normal fw-bold"}
 *                     footerClassName={"p-2"}
 *                     headerClassName={"pt-3"}
 *                     controlsAt={"end"}
 *                     titleAt={"start"}
 *                     scrollVariant={"dark"}
 *                     sleekControl={true}
 *                     scrolled={true}
 *                     closeOnEscape={true}
 *                     closeOnOutsideClick={true}
 *                     showCancelControl={false}
 *                     showConfirmControl={false}
 *                     showFooter={false}
 *                     onCancel={() => setShowYTLinksDialog(false)}
 *                     onClose={() => setShowYTLinksDialog(false)}
 *                     onConfirm={() => {
 *                         setShowYTLinksDialog(false);
 *                     }}
 *                 >
 *                 children
 *                 </Dialog>
 */
const Dialog = React.memo(({
                               className = "",
                               backdropClassName = "",
                               widthClass = "col-10",
                               width,
                               height,
                               maxHeight,
                               minHeight,
                               bgColor = "white",
                               style = {},
                               contentStyle = {},
                               id,
                               controlsAt,
                               confirmId,
                               children,
                               open = false,
                               setOpen,
                               onClose,
                               onEnter,
                               contentFontSize,
                               sleekControl = true,
                               showCancelControl = true,
                               showConfirmControl = true,
                               disableConfirm = false,
                               disableCancel = false,
                               confirmVariant = THEME,
                               animationType = AnimationType.SLIDE_UP,

                               backdropColor = "rgba(0,0,0,0.4)",

                               titleAt = "start",
                               subtitleAt = "start",
                               titleColor,
                               subtitleSize = '13px',
                               subtitleColor,
                               headerContent,

                               contentId,

                               footerClassName = "",
                               cancelClassName = "",
                               confirmClassName = "",
                               controlClassName = "",
                               headerClassName = "",
                               titleClassName = "",
                               subtitleClassName = "",
                               closeClassName = "",
                               contentClassName = "",
                               dividerClassName = "",
                               closeIconClass = "bi bi-x",

                               confirmComponent = null,
                               confirmText = "Confirm",
                               cancelText = "Cancel",

                               title = "",
                               subtitle = "",
                               controls = [],
                               startControls = [],

                               closeTooltip = "",
                               closeVariant = "dark",
                               scrollVariant = 'dark',
                               disableEnforceFocus = true,
                               scrolled = true,
                               showCloseControl = true,
                               showClose = true,
                               showHeader = true,
                               showFooter = true,
                               padded = true,
                               closeOnEscape = true,
                               closeOnOutsideClick = true,
                               onOutsideClick = null,
                               onEscapeClose = null,
                               onConfirm = null,
                               onCancel = null,
                               onHide = null,

                               backdropStyle = {},
                               controlStyle = {},
                               titleStyle = {},
                               subtitleStyle = {},
                               footerStyle = {},
                               headerStyle = {},
                               closeStyle = {},
                               dividerStyle = {},
                               confirmStyle = {},
                               cancelStyle = {},
                           }) => {
    const TAG = 'Modal';
    const modalRef = useRef();

    const animator = new FramerAnimator();

    useEffect(() => {
        // Close on Escape press
        try {
            if (isBoolTrue(open)) {
                const handleEscape = (event) => {
                    if (isBoolTrue(closeOnEscape)) {
                        if (event.key === 'Escape') {
                            // printLog("Modal.Escape pressed");
                            if (checkNull(onEscapeClose)) onEscapeClose(event);
                            handleClose(event);
                        }
                    }
                };
                document.addEventListener('keydown', handleEscape);
                return () => {
                    document.removeEventListener('keydown', handleEscape);
                };
            }
        } catch (e) {
            printLog(TAG, e)
        }
    });


    return (
        // <Container id={"modal-container"}>
        <MUIModal
            open={open}
            onClose={handleClose}
            closeAfterTransition={true}
            disableBackdropClick={false}
            id={"modal-backdrop"}
            // ref={modalRef}
            sx={{display: "grid", placeItems: "center", backgroundColor: backdropColor, ...backdropStyle}}
            className={`modal-backdrop bg-t ${backdropClassName} w-100`}
            onEnter={(node) => {
                // node.firstChild.style.transform = "scale(0.5)";
                // createTimeout(() => {
                //     node.firstChild.style.transform = "scale(1)";
                // }, 300);
                if (checkNull(onEnter)) onEnter(node);
            }}
            onExited={(node) => {
                node.firstChild.style.transform = "scale(0.1)";
            }}
        >
            {/*{animator.setAnimationType(animationType).setDuration(400).setDelay(0).render(*/}
            <DialogContent
                ref={modalRef}
                className={`bg-warningx ${className} ${widthClass}`}
                bgColor={bgColor}
                // style={{transition: "transform 0.3s ease-in-out", ...style}}
                width={width}
                height={height}
                maxHeight={maxHeight}
                minHeight={minHeight}
                scrolled={scrolled}
                scrollVariant={scrollVariant}

                id={id}
                setOpen={setOpen}
                onConfirm={onConfirm}
                onCancel={onCancel}
                onHide={onHide}
                onClose={handleClose}

                disableConfirm={disableConfirm}
                disableCancel={disableCancel}
                controlsAt={controlsAt}
                confirmId={confirmId}
                cancelClassName={cancelClassName}
                confirmClassName={confirmClassName}
                footerClassName={footerClassName}
                controlClassName={controlClassName}
                headerClassName={headerClassName}
                titleClassName={titleClassName}
                subtitleClassName={subtitleClassName}
                closeClassName={closeClassName}
                contentClassName={contentClassName}
                dividerClassName={dividerClassName}
                closeIconClass={closeIconClass}
                confirmText={confirmText}
                confirmComponent={confirmComponent}
                cancelText={cancelText}
                sleekControl={sleekControl}
                showCancelControl={showCancelControl}
                showConfirmControl={showConfirmControl}
                confirmVariant={confirmVariant}

                title={title}
                subtitle={subtitle}
                controls={controls}
                startControls={startControls}

                closeTooltip={closeTooltip}
                showCloseControl={showCloseControl}
                showClose={showClose}
                headerContent={headerContent}
                subtitleColor={subtitleColor}
                titleColor={titleColor}
                subtitleSize={subtitleSize}
                titleAt={titleAt}
                subtitleAt={subtitleAt}

                contentStyle={contentStyle}
                controlStyle={controlStyle}
                titleStyle={titleStyle}
                subtitleStyle={subtitleStyle}
                footerStyle={footerStyle}
                headerStyle={headerStyle}
                closeStyle={closeStyle}
                dividerStyle={dividerStyle}
                cancelStyle={cancelStyle}
                confirmStyle={confirmStyle}
                showHeader={showHeader}
                showFooter={showFooter}
                padded={padded}
                closeVariant={closeVariant}
                contentFontSize={contentFontSize}
                contentId={contentId}
            >
                {children}
            </DialogContent>
            {/*,{*/}
            {/*    className: 'd-flex jc-center al-start w-100x w-100-sm row',*/}
            {/*    onClick: ((event) => {*/}
            {/*        // if (isBoolTrue(closeOnOutsideClick)) {*/}
            {/*        //     if (checkNull(onOutsideClick)) onOutsideClick(event);*/}
            {/*        //     if (checkNull(onClose)) onClose();*/}
            {/*        //     if (checkNull(onHide)) onHide();*/}
            {/*        // }*/}
            {/*    })*/}
            {/*}*/}
            {/*)}*/}
        </MUIModal>
        // </Container>
    )

    function handleClose(event, reason) {
        // if (reason && reason == "backdropClick" && "escapeKeyDown")
        if (!isBoolTrue(closeOnOutsideClick) && checkNull(reason, "") && reason === "backdropClick") {
            // printLog("backdropClick called");
            if (checkNull(onOutsideClick)) onOutsideClick(event);
            return;
        }
        // if (!isBoolTrue(closeOnEscape) && checkNull(reason, "") && reason === "escapeKeyDown") {
        //     printLog("escapeKeyDown called");
        //     if (checkNull(onEscapeClose)) onEscapeClose(event);
        //     return;
        // }
        if (checkNull(onClose)) onClose();
        if (checkNull(onHide)) onHide();
        // if (checkNull(onCancel)) onCancel();
        // if (checkNull(setOpen)) setOpen(false);
    }
});


export default Dialog;
